export const columnsTableStock = [
  {
    Header: "checkbox",
    accessor: "checkbox",
  },
  {
    Header: "Код",
    accessor: "id",
  },
  {
    Header: "Автор",
    accessor: "user_name",
  },
  {
    Header: "Контрагент",
    accessor: "counterparty_name",
  },
  {
    Header: "Дата",
    accessor: "date",
  },
  {
    Header: "Час",
    accessor: "hours",
  },
];
